import { Box, Chip, Divider, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import useColors from "../../../../../api/hooks/useColors";
import LoadingIcon from "../../../../../components/LoadingIcon";
import { EnvFeatureFlagContext } from "../../../../../contexts/EnvFeaturesContext";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ProtectionLevelText } from "../../../../../utils/constants";
import { severities } from "../../../../stack/environment/icons/iconExport";
import IntegrationImage from "../../../../stack/integrations/components/IntegrationImage";
import EntitiesChipList from "../../../controls/components/ControlMisconfiguration/relatedEntities/EntitiesChipList";
import DetectionLabelIcon from "../../../detections/components/DetectionLabelIcon";
import CoverageControlsLabel from "../../../steps/components/CoverageControlsLabel";
import ProtectionLevel from "../../../steps/components/ProtectionLevel";
import ThreatIntelAccordion from "../../../steps/components/ThreatIntelAccordion";

const NonExecutionTypeContent = ({
  step,
  fullNode,
  complexMisconfiguredEntitiesByType,
  handleEntityChipStepClick,
}) => {
  const { scenariosDemoMode } = useContext(EnvFeatureFlagContext);
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      {fullNode?.tooltip && (
        <Box
          sx={{
            borderTop: `1px dashed ${colors.gray_main}`,
            borderBottom: `1px dashed ${colors.gray_main}`,
          }}
        >
          <Typography variant="caption">{fullNode.tooltip}</Typography>
        </Box>
      )}
      <Grid
        item
        xs={12}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"flex-start"}
        gap={2}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Typography variant="subtitle1" sx={{ lineHeight: "20px" }}>
            {step?.name}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle1" sx={{ lineHeight: "20px" }}>
            #{step?.step_id}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        flexWrap={"wrap"}
        gap={2}
        flexWrap={"wrap"}
      >
        {step?.mitigating_controls_tools_set.map((toolName, index) => (
          <>
            <IntegrationImage name={toolName} width={"16px"} newLogo={true} />
            {step?.mitigating_controls_tools_set?.length - 1 !== index && (
              <Divider flexItem orientation="vertical" />
            )}
          </>
        ))}{" "}
        {Boolean(step?.mitigating_controls_tools_set?.length) && (
          <Divider flexItem orientation="vertical" />
        )}
        <>
          <ProtectionLevel level={step?.protection_level} />
          <Box>
            {step?.protection_level !== ProtectionLevelText.MISSING_CONTROLS ? (
              <CoverageControlsLabel
                compliant={step.protection_stats?.compliant}
                total={step.protection_stats?.total}
              />
            ) : (
              <Chip
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      variant="overline"
                      sx={{ color: colors.text_secondary }}
                    >
                      -
                    </Typography>
                  </Box>
                }
                sx={{
                  borderRadius: "12px",
                  background: "transparent",
                  border: "0.5px solid " + colors.grey_light,
                  alignItems: "center",
                  display: "flex",
                  padding: "5px 0px",
                  height: "24px",
                }}
              />
            )}
          </Box>
        </>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} display={"flex"} alignItems={"center"} gap={1}>
        {step.is_detected && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DetectionLabelIcon />
          </Box>
        )}
        <SvgToIcon
          IconLogo={severities.HighSeverityIcon}
          style={{
            width: "16px",
            height: "16px",
          }}
        />
        <Typography variant="caption">
          Part of {step?.number_of_scenarios} Attack Paths{" "}
          {step.scenario_involvement_percentage > 0 &&
            " (" + step.scenario_involvement_percentage + "%)"}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} display={"flex"} flexDirection={"column"} gap={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography variant="subtitle2">What is the risk?</Typography>
          <Typography variant="body2">{step?.story_one_line}</Typography>
        </Box>
        <Box
          sx={{
            paddingBottom: "8px",
          }}
        >
          {step?.misconfigured_entity_ids?.length > 0 &&
            (complexMisconfiguredEntitiesByType ? (
              <Box display={"flex"} flexDirection={"column"} gap={1}>
                <Typography variant="subtitle2">
                  What entities are affected?
                </Typography>
                <EntitiesChipList
                  entitiesByType={complexMisconfiguredEntitiesByType}
                  handleChipClick={(entityType) =>
                    handleEntityChipStepClick(step.step_id, entityType)
                  }
                />
              </Box>
            ) : (
              <LoadingIcon size={20} />
            ))}
        </Box>
        {scenariosDemoMode && <ThreatIntelAccordion step={step} size="small" />}
      </Grid>
    </Box>
  );
};

export default NonExecutionTypeContent;
